import React from 'react'

const Divider = () => {
    return (
        <div className="divider-section"></div>
    )
}

export default Divider
